import React, { cloneElement } from 'react';
import { Avatar } from 'lib/avatar';
import { getRem } from 'lib/core';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const StyledListItemGraphic = styled(({ $isDisabled = false, $isStyledAvatar = false, children, ...other }) =>
  cloneElement(children, { $isDisabled, $isStyledAvatar, ...other })
)`
  flex-shrink: 0;
  margin-right: ${getRem(12)};
  pointer-events: none;
  ${({ $isStyledAvatar, children }) =>
    children.type !== Avatar &&
    !$isStyledAvatar &&
    css`
      display: flex;
      fill: ${({ $isDisabled, theme }) =>
        $isDisabled ? theme.color.text.light.disabled.value : theme.color.text.light.secondary.value};
      height: ${getRem(24)};
      width: ${getRem(24)};
    `};
`;

const ListItemGraphic = ({ isDisabled, isStyledAvatar, ...props }) => (
  <StyledListItemGraphic $isDisabled={isDisabled} $isStyledAvatar={isStyledAvatar} {...props} />
);

ListItemGraphic.propTypes = {
  /** Changes appearance to look visually non-interactable */
  isDisabled: PropTypes.bool,
  /** Changes appearance if children is Avatar styled with styled-components */
  isStyledAvatar: PropTypes.bool,
};

export { ListItemGraphic };
